export default __webpack_public_path__ + "static/media/three-dots.05741647.svg";